export default __webpack_public_path__ + "static/media/project1.add7058b.png";